<template>
  <div class="new-container profit-container">
    <div class="container">
      <Header/>
      <div class="main">
        <div class="list-container">
          <el-form class="submit_form" :inline="true" ref="submitFormRef" :rules="submitFormRules" :model="submitForm">
            <div class="battery-container">
              <div class="left">
                <div class="left-title">
                  <div class="header">{{ submitForm.series }}S{{ submitForm.parallel }}P
                    {{ (submitForm.parallel * submitForm.cell_capacity).toFixed(1) }}Ah {{ total_battery_voltage2 }}V
                  </div>
                </div>
                <div class="left-top-container">
                  <div class="left-content">
                    <span>Battery</span>
                    <hr>
                  </div>
                  <div class="right-content">
                    <div class="input row">
                      <el-form-item class="item-title" prop="cell_type" label="Cell Type:">
                        <el-select v-model="submitForm.cell_type" @change="cellTypeChange">
                          <el-option v-for="item in cellType" :key="item.value" :value="item.value"
                                     :label="item.label"></el-option>
                        </el-select>
                        <el-checkbox @change="ratingsChange" v-model="submitForm.ratings"
                                     style="margin-top: 10px;color:#fff;">Use C ratings
                        </el-checkbox>
                      </el-form-item>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="series" label="#">
                        <el-input v-model="submitForm.series" class="el-input--one" style="width: 80px;"></el-input>
                        <span style="margin-right: 15px;">Series</span>
                        <el-input v-model="submitForm.parallel" class="el-input--one" style="width: 80px;"></el-input>
                        <span>Parallel</span>
                      </el-form-item>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="cell_capacity" :label="capacity_label">
                        <el-input v-model="submitForm.cell_capacity" class="el-input--one"></el-input>
                      </el-form-item>
                      <span>Ah</span>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="cont_discharge_a" label="Cont. Discharge">
                        <el-input v-model="submitForm.cont_discharge_a" :disabled="cont_discharge_disabled"
                                  class="el-input--one"
                                  style="width: 70px;"></el-input>
                        <span style="margin-right: 15px;">A</span>
                        <el-input v-model="submitForm.cont_discharge_c" :disabled="!cont_discharge_disabled"
                                  class="el-input--one"
                                  style="width: 70px;"></el-input>
                        <span>C</span>
                      </el-form-item>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="max_discharge_a" label="Max. Discharge">
                        <el-input v-model="submitForm.max_discharge_a" :disabled="max_discharge_disabled"
                                  class="el-input--one"
                                  style="width: 70px;"></el-input>
                        <span style="margin-right: 15px;">A</span>
                        <el-input v-model="submitForm.max_discharge_c" :disabled="!max_discharge_disabled"
                                  class="el-input--one"
                                  style="width: 70px;"></el-input>
                        <span>C</span>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="left-bottom-container">
                  <div class="left-content">
                    <span>Drive Train</span>
                    <hr>
                  </div>
                  <div class="right-content">
                    <div class="input row">
                      <el-form-item class="item-title" prop="motor_kv" label="Motor">
                        <el-input v-model="submitForm.motor_kv" class="el-input--one"
                                  style="width: 70px;"></el-input>
                        <span style="margin-right: 15px;">kv</span>
                        <el-input v-model="submitForm.motor_poles" class="el-input--one"
                                  style="width: 70px;"></el-input>
                        <span>poles</span>
                      </el-form-item>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="efficiency" label="Efficiency">
                        <el-input v-model="submitForm.efficiency" class="el-input--one"></el-input>
                      </el-form-item>
                      <span>%</span>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="wheel_size" label="Wheel size">
                        <el-input v-model="submitForm.wheel_size" class="el-input--one"></el-input>
                      </el-form-item>
                      <span>mm</span>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="motor_pulley" label="Motor pulley">
                        <el-input v-model="submitForm.motor_pulley" class="el-input--one"></el-input>
                      </el-form-item>
                      <span>Teeth</span>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="wheel_pulley" label="Wheel pulley">
                        <el-input v-model="submitForm.wheel_pulley" class="el-input--one"></el-input>
                      </el-form-item>
                      <span>Teeth</span>
                    </div>
                    <div class="input row">
                      <el-form-item class="item-title" prop="avg_energy_use" label="Avg. Energy Use">
                        <el-input v-model="submitForm.avg_energy_use" class="el-input--one"></el-input>
                      </el-form-item>
                      <span>wh/km</span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="right">
                <div class="right-container">
                  <div class="right-item">
                    <div class="container-img">
                      <img src="@/assets/images/p1.jpg" alt="">
                    </div>
                    <div class="container-title">Range & Speed</div>
                    <div class="output row">
                      <label class="col-xs-4">Gear<br>Ratio</label>
                      <span class="number-calc col-xs-4">{{ gear_ratio }}</span>
                      <span class="col-xs-4"></span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Loaded<br>Speed:</label>
                      <span class="number-calc col-xs-4">{{ loaded_speed }}</span>
                      <span class="col-xs-4">km/h</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Loaded<br>Speed:</label>
                      <span class="number-calc col-xs-4">{{ loaded_speed_m }}</span>
                      <span class="col-xs-4">mph</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Max<br>Speed:</label>
                      <span class="number-calc col-xs-4">{{ max_speed }}</span>
                      <span class="col-xs-4">km/h</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Max<br>Speed:</label>
                      <span class="number-calc col-xs-4">{{ max_speed_m }}</span>
                      <span class="col-xs-4">mph</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Estimated <br>Range:</label>
                      <span class="number-calc col-xs-4">{{ estimated_range }}</span>
                      <span class="col-xs-4">km</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Estimated <br>Range:</label>
                      <span class="number-calc col-xs-4">{{ estimated_range_m }}</span>
                      <span class="col-xs-4">mi</span>
                    </div>
                  </div>
                  <div class="right-item">
                    <div class="container-img">
                      <img src="@/assets/images/p2.jpg" alt="">
                    </div>
                    <div class="container-title">Battery Specification</div>
                    <div class="output row">
                      <label class="col-xs-4">Total<br>battery<br>voltage:</label>
                      <span class="number-calc col-xs-4">{{ total_battery_voltage }}</span>
                      <span class="col-xs-4">V<br>(Volts)</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Total<br>battery<br>capacity:</label>
                      <span class="number-calc col-xs-4">{{ total_battery_capacity }}</span>
                      <span class="col-xs-4">Ah<br>(Amp-<br>hours)</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Total<br>battery<br>energy:</label>
                      <span class="number-calc col-xs-4">{{ total_battery_energy }}</span>
                      <span class="col-xs-4">Wh<br>(Watt-<br>hours)</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Cont.<br>battery<br>power:</label>
                      <span class="number-calc col-xs-4">{{ cont_battery_power }}</span>
                      <span class="col-xs-4">W<br>(Watts)</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Max<br>battery<br>power:</label>
                      <span class="number-calc col-xs-4">{{ max_battery_power }}</span>
                      <span class="col-xs-4">W<br>(Watts)</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Cont.<br>discharge:</label>
                      <span class="number-calc col-xs-4">{{ cont_discharge }}</span>
                      <span class="col-xs-4">A<br>(Amps)</span>
                    </div>
                    <div class="output row">
                      <label class="col-xs-4">Max<br>discharge:</label>
                      <span class="number-calc col-xs-4">{{ max_discharge }}</span>
                      <span class="col-xs-4">A<br>(Amps)</span>
                    </div>
                  </div>
                  <div class="right-item">
                    <div class="container-img">
                      <img src="@/assets/images/p3.jpg" alt="">
                    </div>
                    <div class="container-title">Drive Train Specification</div>
                    <div class="output row">
                      <span class="number-calc col-xs-7">{{ max_erpm }}</span>
                      <label class="col-xs-5">Max<br>ERPM</label>
                    </div>
                    <div class="output row">
                      <span class="number-calc col-xs-7">{{ loaded_erpm }}</span>
                      <label class="col-xs-5">Loaded<br>ERPM</label>
                    </div>
                    <div class="output row">
                      <span class="number-calc col-xs-7">{{ max_motor_rpm }}</span>
                      <label class="col-xs-5">Max<br>motor<br>RPM</label>
                    </div>
                    <div class="output row">
                      <span class="number-calc col-xs-7">{{ loaded_motor_rpm }}</span>
                      <label class="col-xs-5">Loaded<br>motor<br>RPM</label>
                    </div>
                    <div class="output row">
                      <span class="number-calc col-xs-7">{{ max_wheel_rpm }}</span>
                      <label class="col-xs-5">Max<br>wheel<br>RPM</label>
                    </div>
                    <div class="output row">
                      <span class="number-calc col-xs-7">{{ loaded_wheel_rpm }}</span>
                      <label class="col-xs-5">Loaded<br>wheel<br>RPM</label>
                    </div>
                  </div>
                </div>
                <div class="container-img">
                  <img src="@/assets/images/esk/RF5MA.png" alt="">
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>

.el-form {
  .el-form-item {
    margin-bottom: 0;

    /deep/ .el-form-item__label {
      color: #fff;
    }

    /deep/ .el-form-item__content {
    }
  }

  /deep/ .form-item-row.el-row {
    background: #444;
    padding: 10px;
  }

  /deep/ .el-input--one .el-input__inner {
    width: 60px;
    margin-right: 5px;
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    background: #444;
  }

  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
}

.new-container {
  background-color: #000;
  height: 100%;
  overflow: auto;
}

.container {
  width: 100%;
  height: auto;
  margin: auto;
  overflow: hidden;
  background: #fff;

  .main {
    width: 100%;
    margin: auto;
    background: #1c1c1c;
  }
}

.list-container {
  width: 80%;
  padding-top: 50px;
  padding-bottom: 50px;
  margin: auto;

  .el-checkbox.ng-untouched {
    margin-top: 5px;
    color: #aaa;
  }

  .form-series, .form-parallel {
    max-width: 80px;
  }

  .battery-container {
    display: flex;
    color: #fff;

    .left {
      width: 50%;
      padding-right: 30px;

      .header {
        width: 100%;
        font-size: 35px;
        margin: 50px 0;
        text-align: center;
        font-weight: bold;
      }

      .left-title {
        font-size: 25px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .left-top-container {
        display: flex;

        .left-content {
          width: 30%;
          color: #000;
          background: #f1f1f1;
          padding-top: 20px;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          text-align: center;
          font-weight: bold;

          span {
            font-size: 25px;
            padding: 20px 20px;
          }

          hr {
            width: 40%;
            border: 1.5px solid #fbaf3f;
            background: #fbaf3f;
          }
        }

        .right-content {
          width: 60%;
          border-top: 1px solid #fff;
        }
      }

      .left-bottom-container {
        width: 100%;
        display: flex;
        margin-top: 30px;

        .left-content {
          width: 30%;
          background: #fbaf3f;
          color: #fff;
          padding-top: 20px;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          text-align: center;
          font-weight: bold;

          span {
            font-size: 25px;
          }

          hr {
            width: 50%;
            border: 1.5px solid #000;
            background: #000;
          }
        }

        .right-content {
          width: 60%;
          border-top: 1px solid #fff;
        }
      }

      .row {
        display: flex;
        flex-wrap: wrap;
      }

      .input.row {
        justify-content: flex-start;
        align-items: center;
        background-color: #1c1c1c;
        margin: 1px;
        color: #fff;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 10px;
        border-bottom: 1px solid #fff;

        label {
          display: flex;
          align-items: center;
        }
      }
    }

    .right {
      width: 50%;

      .right-container {
        display: flex;

        .right-item {

          .container-img {
            width: 100%;

            img {
              width: 100%;
            }
          }

          .container-title {
            font-size: 15px;
            margin: 10px 1px;
          }

          & {
            width: calc(100% / 3 - 20px);
          }

          margin-right: 20px;

          .row {
            display: flex;
            flex-wrap: wrap;
          }

          .output.row {
            justify-content: space-evenly;
            align-items: center;
            margin: 5px;
            padding: 5px;
            font-size: 13px;
            border: 1px solid #ccc;
            box-shadow: 1px 0px 1px 1px #ccc;

            .number-calc {
              font-size: 1.3rem;
              font-weight: 600;
            }

            .col-xs-4:nth-child(1) {
              padding-left: 5px;
            }

            .col-xs-4:nth-child(2n) {
              width: 40%;
              text-align: center;
              color: #fbaf3f;
            }

            .col-xs-4:nth-child(2n+1) {
              width: 30%;
            }
          }

          &:nth-child(3) {
            .output.row {
              .col-xs-7 {
                width: 60%;
                text-align: center;
                color: #fbaf3f;
              }

              .col-xs-5 {
                width: 40%;
                text-align: left;
              }
            }
          }

          .yellow {
            background-color: var(--color-yellow);
          }

          .red {
            background-color: #d90000;
          }

          .orange {
            background-color: #ff8900;
          }

          .dark {
            background-color: #2c2c2c;
          }

          .purple {
            background-color: var(--color-purple);
          }

          .green {
            background-color: #61b92b;
          }

          .pink {
            background-color: var(--color-pink);
          }
        }

      }

      .container-img {
        width: 100%;
        margin-top: 10px;

        img {
          width: 88%;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .container {
    width: 100%;

    .top {
      a {
        width: 25%;
      }
    }

    .list-container {
      width: 95%;

      .battery-container {
        flex-direction: column;

        .left {
          width: 100%;
          padding-right: 0;

          .header {
            font-size: 30px;
          }

          .left-top-container {
            flex-direction: column;

            .left-content {
              width: 100%;
              border-radius: 0;

              span {
                font-size: 20px;
              }

              hr {
                width: 15%;
              }
            }

            .right-content {
              width: 100%;
            }
          }

          .left-bottom-container {
            flex-direction: column;

            .left-content {
              width: 100%;
              border-radius: 0;

              span {
                font-size: 20px;
              }

              hr {
                width: 20%;
              }
            }

            .right-content {
              width: 100%;
            }
          }
        }

        .right {
          width: 100%;
          margin-top: 30px;

          .container-img {
            img {
              width: 100%;
            }
          }

          .right-container {
            flex-direction: column;

            .right-item {
              margin-top: 20px;

              .container-title {
                font-size: 14px;
                margin-bottom: 10px;
              }

              &:nth-child(1) {
                width: 100%;
              }

              &:nth-child(2) {
                width: 100%;
              }

              &:nth-child(3) {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 1601px) {
  .list-container {
    .battery-container {
      .left {
        .header {
          margin: 75px 0;
        }
      }

      .right {
        .container-img {
          width: 100%;
          margin-top: 10px;

          img {
            width: 70%;
          }
        }
      }
    }
  }
}

@media (min-width: 1001px) and (max-width: 1600px) {
  .list-container {
    .battery-container {
      .left {
        width: 40%;

        .left-top-container {
          .left-content {
            span {
              font-size: 23px;
            }
          }

          .right-content {
            width: 70%;
          }
        }

        .left-bottom-container {
          .left-content {
            span {
              font-size: 23px;
            }
          }

          .right-content {
            width: 70%;
          }
        }
      }

      .right {
        width: 60%;

        .container-img {
          img {
            width: 61%;
          }
        }
      }
    }
  }
}
</style>

<script>
// import qs from 'qs'
import Header from '@/components/Header'

export default {
  components: {
    Header
  },
  data() {
    return {
      loading: false,
      cellType: [
        {
          value: 3.7,
          label: 'Li-polymer: 3.7V'
        },
        {
          value: 3.6,
          label: 'Li-ion: 3.6V'
        },
        {
          value: 3.2,
          label: 'LiFePO4: 3.2V'
        }
      ],
      capacity_label: 'Cell Capacity',
      cont_discharge_disabled: false,
      max_discharge_disabled: false,
      gear_ratio: 1,
      loaded_speed: 1,
      loaded_speed_m: 1,
      max_speed: 1,
      max_speed_m: 1,
      estimated_range: 1,
      estimated_range_m: 1,
      km_to_mp: 0.6214,
      total_battery_voltage: 1,
      total_battery_capacity: 1,
      total_battery_energy: 1,
      cont_battery_power: 1,
      max_battery_power: 1,
      cont_discharge: 1,
      max_discharge: 1,
      max_erpm: 1,
      loaded_erpm: 1,
      max_motor_rpm: 1,
      loaded_motor_rpm: 1,
      max_wheel_rpm: 1,
      loaded_wheel_rpm: 1,
      total_battery_voltage2: 1,
      battery_voltage: 4.2,
      // 表单绑定对象
      submitForm: {
        cell_type: 3.7,
        ratings: false,
        series: 10,
        parallel: 4,
        cell_capacity: 3,
        cont_discharge_a: 10,
        cont_discharge_c: 10,
        max_discharge_a: 20,
        max_discharge_c: 20,
        motor_kv: 170,
        motor_poles: 14,
        efficiency: 90,
        wheel_size: 110,
        motor_pulley: 15,
        wheel_pulley: 40,
        avg_energy_use: 11.2

      },
      submitFormRules: {},
      submitted: false,
      code: ''
    }
  },
  watch: {
    submitForm: {
      handler(newVal) {
        this.gear_ratio = this.getGearRatio().toFixed(1)
        this.loaded_speed = this.getLoadedSpeed().toFixed(1)
        this.loaded_speed_m = (this.getLoadedSpeed() * this.km_to_mp).toFixed(1)
        this.max_speed = this.getMaxSpeed().toFixed(1)
        this.max_speed_m = (this.getMaxSpeed() * this.km_to_mp).toFixed(1)
        this.total_battery_voltage = this.getTotalBatteryVoltage().toFixed(0)
        this.total_battery_capacity = this.getTotalBatteryCapacity().toFixed(1)
        this.total_battery_energy = this.getTotalBatteryEnergy().toFixed(0)
        this.cont_battery_power = this.getContBatteryPower().toFixed(0)
        this.max_battery_power = this.getMaxBatteryPower().toFixed(0)
        this.cont_discharge = this.getContDischargeA().toFixed(1)
        this.max_discharge = this.getMaxDischargeA().toFixed(1)
        this.max_erpm = this.getMaxErpm().toFixed(0)
        this.loaded_erpm = this.getLoadedErpm().toFixed(0)
        this.max_motor_rpm = this.getMaxMotorRpm().toFixed(0)
        this.loaded_motor_rpm = this.getLoadedMotorRpm().toFixed(0)
        this.max_wheel_rpm = this.getMaxWheelRpm().toFixed(0)
        this.loaded_wheel_rpm = this.getLoadedWheelRpm().toFixed(0)
        this.total_battery_voltage2 = (this.submitForm.series * this.battery_voltage).toFixed(1)
        this.estimated_range = this.getEstimatedRange().toFixed(1)
        this.estimated_range_m = (this.getEstimatedRange() * this.km_to_mp).toFixed(1)
      },
      deep: true
    }
  },
  created() {
    this.gear_ratio = this.getGearRatio().toFixed(1)
    this.loaded_speed = this.getLoadedSpeed().toFixed(1)
    this.loaded_speed_m = (this.getLoadedSpeed() * this.km_to_mp).toFixed(1)
    this.max_speed = this.getMaxSpeed().toFixed(1)
    this.max_speed_m = (this.getMaxSpeed() * this.km_to_mp).toFixed(1)
    this.total_battery_voltage = this.getTotalBatteryVoltage()
    this.total_battery_capacity = this.getTotalBatteryCapacity().toFixed(1)
    this.total_battery_energy = this.getTotalBatteryEnergy().toFixed(0)
    this.cont_battery_power = this.getContBatteryPower().toFixed(0)
    this.max_battery_power = this.getMaxBatteryPower().toFixed(0)
    this.cont_discharge = this.getContDischargeA().toFixed(1)
    this.max_discharge = this.getMaxDischargeA().toFixed(1)
    this.max_erpm = this.getMaxErpm().toFixed(0)
    this.loaded_erpm = this.getLoadedErpm().toFixed(0)
    this.max_motor_rpm = this.getMaxMotorRpm().toFixed(0)
    this.loaded_motor_rpm = this.getLoadedMotorRpm().toFixed(0)
    this.max_wheel_rpm = this.getMaxWheelRpm().toFixed(0)
    this.loaded_wheel_rpm = this.getLoadedWheelRpm().toFixed(0)
    this.total_battery_voltage2 = this.submitForm.series * this.battery_voltage
    this.estimated_range = this.getEstimatedRange().toFixed(1)
    this.estimated_range_m = (this.getEstimatedRange() * this.km_to_mp).toFixed(1)
    // const arr = ['A', 'C', 'B', 'D']
    // const newArr = arr.sort().join(',')
    // console.log(newArr)
    // this.open()
  },
  methods: {
    getTotalBatteryVoltage() {
      return this.submitForm.cell_type * this.submitForm.series
    },
    getGearRatio() {
      // 传动比：=轮子齿数/电机输出齿数
      return this.submitForm.wheel_pulley / this.submitForm.motor_pulley
    },
    getLoadedSpeed() {
      // 负载速度：0.9*（（电压x电机kv/传动比x3.14x轮子直径mmx60）/1000）
      return ((this.submitForm.efficiency / 100) * ((this.getTotalBatteryVoltage() * this.submitForm.motor_kv / this.getGearRatio() * Math.PI * (this.submitForm.wheel_size / 1000) * 60) / 1000))
    },
    getMaxSpeed() {
      return (((this.submitForm.cell_type * this.submitForm.series * this.submitForm.motor_kv / this.getGearRatio() * Math.PI * (this.submitForm.wheel_size / 1000) * 60) / 1000))
    },

    getTotalBatteryCapacity() {
      return this.submitForm.cell_capacity * this.submitForm.parallel
    },
    getTotalBatteryEnergy() {
      // 电池总容量
      return this.submitForm.cell_type * this.submitForm.series * this.submitForm.parallel * this.submitForm.cell_capacity
    },
    getContBatteryPower() {
      // 电池额定功率  电池额定电压*持续放电电流*并数
      return this.submitForm.ratings ? this.getTotalBatteryVoltage() * this.submitForm.cont_discharge_c * this.submitForm.cell_capacity * this.submitForm.parallel : this.getTotalBatteryVoltage() * this.submitForm.cont_discharge_a * this.submitForm.parallel
    },
    getMaxBatteryPower() {
      return this.submitForm.ratings ? this.getTotalBatteryVoltage() * this.submitForm.max_discharge_c * this.submitForm.parallel * this.submitForm.cell_capacity : this.getTotalBatteryVoltage() * this.submitForm.max_discharge_a * this.submitForm.parallel
    },
    getContDischargeA() {
      // 单颗持续放电电流*并数
      return this.submitForm.cont_discharge_a * this.submitForm.parallel
    },
    getContDischargeC() {
      // 单颗持续放电电流*并数
      return this.submitForm.cont_discharge_c * this.submitForm.parallel
    },
    getMaxDischargeA() {
      return this.submitForm.max_discharge_a * this.submitForm.parallel
    },
    getMaxDischargeC() {
      return this.submitForm.max_discharge_c * this.submitForm.parallel
    },
    getMaxErpm() {
      return this.submitForm.cell_type * this.submitForm.series * this.submitForm.motor_kv * (this.submitForm.motor_poles / 2)
    },
    getLoadedErpm() {
      return this.getMaxErpm() * this.submitForm.efficiency / 100
    },
    getMaxMotorRpm() {
      return this.submitForm.cell_type * this.submitForm.series * this.submitForm.motor_kv
    },
    getLoadedMotorRpm() {
      return this.getMaxMotorRpm() * this.submitForm.efficiency / 100
    },
    getMaxWheelRpm() {
      return this.submitForm.cell_type * this.submitForm.series * this.submitForm.motor_kv / this.getGearRatio()
    },
    getLoadedWheelRpm() {
      return this.getMaxWheelRpm() * this.submitForm.efficiency / 100
    },
    getEstimatedRange() {
      return this.total_battery_energy / this.submitForm.avg_energy_use
    },
    ratingsChange(val) {
      if (val) {
        // use C ratings
        this.capacity_label = 'Pack Capacity'
        this.cont_discharge_disabled = true
        this.max_discharge_disabled = true
        this.cont_discharge = (this.getContDischargeC() * this.submitForm.cell_capacity).toFixed(2)
        this.max_discharge = (this.getMaxDischargeC() * this.submitForm.cell_capacity).toFixed(2)
      } else {
        this.capacity_label = 'Cell Capacity'
        this.cont_discharge_disabled = false
        this.max_discharge_disabled = false
        this.cont_discharge = this.getContDischargeA().toFixed(2)
        this.max_discharge = this.getMaxDischargeA().toFixed(2)
      }
    },
    cellTypeChange(val) {
      const select = parseFloat(val)
      // console.log(select)
      if (select === 3.6 || select === 3.7) {
        this.battery_voltage = 4.2
      } else {
        this.battery_voltage = 3.6
      }
    },
    submitFormChanged(cur, old) {
      console.log(cur, old)
    }
  }
}
</script>
